module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 10.25df7ac9.png";